import { store } from '../../../../../resources/frontend/js/store';

export const questionProps = {
    index: {
        type: Number,
        required: true,
    },

    content: {
        type: Object,
        required: true,
    },

    preHook: {
        type: Function,
        required: false,
        default: () => {},
    },

    afterHook: {
        type: Function,
        required: false,
        default: () => {},
    },
};

export const getQuestionName = props => {
    return props.content?.lead_service_name?.value || `extradata-question-${props.index}`;
};

export const addExtraData = (name, data) => {
    store.commit('quiz/addExtradata', { name, data });
};

export const storeExtraData = (name, key, value) => {
    store.commit('quiz/storeExtradata', { name, key, value });
};

export const getExtraData = (value, name) => {
    return store.getters['quiz/getExtraData'](value, name);
};

export const handleResetValidation = name => {
    if (store.getters['form/getFieldData']('preValidate', name) === false) {
        store.commit('form/setFieldData', { name: name, key: 'preValidate', value: null });
        store.commit('form/setFieldData', { name: name, key: 'validate', value: null });
    }
};

const handleMask = event => {
    if (store.getters['quiz/getExtraData']('mask', this.name)) {
        const element = event.target;
        const value = this.useMask('quiz', element, this.name);
        this.storeExtraData('value', value);
    }
};
